<template>
    <div class="session type--align-center v--50">
        <!--{{instance}}-->
        <div v-if="instance.icon !== null && instance.icon !== ''" class="session__icon">
            <IconSession :name="instance.icon"/>
        </div>
        <div class="session__bottom r v--10">
            <div class="session__count type--pre-header type--pre-header--bold type--color--sp-green-dark-2" v-html="finalTopicTitle"></div>
            <h1 class="session__title type--h1--default" v-html="instance.title"></h1>
            <p v-if="instance.description" class="session__description type--p" v-html="instance.description"></p>
        </div>
    </div>
</template>

<script>
import IconSession from "@c/IconSession.vue"
export default {
    components: {
        IconSession,
    },
    computed: {
        sessionIcon() {
            return "section/" + this.instance.icon;
        },
        finalTopicTitle() {
            return this.instance.count !== "" && this.instance.count !== null ? this.instance.title : this.topicTitle
        },
    },
    props: {
        instance: Object,
        topicTitle: String,
    },
}
</script>

<style lang="scss">
@import "@s/_mixins.scss";
@import "@s/_vars.scss";
.session__icon {
    margin-top: rem(70px);
}
.session__title {

}
.session__description {
    margin-top: rem(9px);
}
.session__bottom {
    padding-bottom: rem(7px);
}
</style>